<template>
  <div>
    <b-row>
      <b-col
        v-for="item in ocorrencias"
        :key="item.id"
        cols="12"
        md="4"
        class="d-flex"
      >
        <b-card
          :title="item.titulo"
          class="w-100"
        >
          <b-row>
            <b-col align="left">
              <b-badge
                size="xs"
                variant="primary"
              >{{
                new Date(item.dataHora) | formatDatetime
              }}</b-badge>
            </b-col>
            <b-col align="right">
              <b-button
                variant="outline-primary"
                size="sm"
                align="right"
                :to="`/ocorrencia/${item.id}`"
              >
                ver <feather-icon icon="ArrowRightIcon" />
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <infinite-loading @infinite="infiniteHandler">
      <div slot="no-more">
        Já carregamos todos os ocorrencias =)
      </div>
      <no-content-ocorrencia slot="no-results" />
      <div slot="spinner">
        Carregando...
      </div>
    </infinite-loading>
  </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
import NoContentOcorrencia from './NoContentOcorrencia.vue'

export default {
  components: {
    InfiniteLoading,
    NoContentOcorrencia,
  },
  data() {
    return {
      pagination: { page: 1, size: 10 },
    }
  },
  computed: {
    ocorrencias() {
      return this.$store.state.livroOcorrencia.ocorrencias
    },
  },
  beforeCreate() {
    this.$store.dispatch('livroOcorrencia/clear')
  },
  methods: {
    infiniteHandler($state) {
      this.$store
        .dispatch('livroOcorrencia/fetchOcorrencias', { pagina: this.pagination.page })
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.pagination.page += 1
            $state.loaded()
          } else {
            $state.complete()
          }
        })
        .catch(() => $state.complete())
    },
  },
}
</script>
